import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class BidSearch extends BaseModel {
  lot_no = null;
  amount = null;
  bidder_uuid = null;
  stock_no = null;
  is_winner = null;
  highest_bid = false;

  rules = {};

  attributeLabels = {
    lot_no: i18n.t('Lot'),
    amount: i18n.t('Amount'),
    bidder_uuid: i18n.t('Bidder'),
    stock_no: i18n.t('Stock'),
    is_winner: i18n.t('Is Winner'),
    highest_bid: i18n.t('Highest Bid'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (data.highest_bid) {
      data.highest_bid = 'true'
    } else {
      delete data.highest_bid
    }

    return data;
  }
}
